import { Button } from "@project/shared";
import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/react";
import { useRouter } from "next/router";
import ScrollContainer from "react-indiana-drag-scroll";
const Card = /*#__PURE__*/styled("div")({
  name: "Card",
  class: "c16tlsbg"
});
const ImageContainer = /*#__PURE__*/styled(ScrollContainer)({
  name: "ImageContainer",
  class: "ijq3zky",
  vars: {
    "ijq3zky-0": [({
      count
    }) => count > 1 ? `calc(${100 / count}% - 16px)` : "100%"]
  }
});
const Tag = /*#__PURE__*/styled("div")({
  name: "Tag",
  class: "t1xw1gg0"
});
const InfoContainer = /*#__PURE__*/styled("div")({
  name: "InfoContainer",
  class: "i1asj5w6"
});
const TitleWrapper = /*#__PURE__*/styled("div")({
  name: "TitleWrapper",
  class: "te5s0xz",
  vars: {
    "te5s0xz-0": [({
      original
    }) => original ? "9px" : "33px"]
  }
});
const Price = /*#__PURE__*/styled("div")({
  name: "Price",
  class: "p1m55yph"
});
const Content = /*#__PURE__*/styled("p")({
  name: "Content",
  class: "c9yiofh"
});
const PlanName = /*#__PURE__*/styled("p")({
  name: "PlanName",
  class: "px0hhu3",
  vars: {
    "px0hhu3-3": [({
      original
    }) => original ? "block" : "contents"]
  }
});
const TagWrapper = /*#__PURE__*/styled("div")({
  name: "TagWrapper",
  class: "t1ji98j0",
  vars: {
    "t1ji98j0-0": [({
      original
    }) => original ? "9px" : "-20px"],
    "t1ji98j0-1": [({
      original
    }) => original ? "37px" : "16px"],
    "t1ji98j0-2": [({
      original
    }) => original ? "9px" : "-17px"],
    "t1ji98j0-3": [({
      original
    }) => original ? "8px" : "20px"]
  }
});
interface Props {
  planName?: string;
  tag?: string;
  category?: string;
  persons?: string;
  title: string;
  price?: string;
  group?: number;
  description: string;
  images?: string[];
  original?: boolean;
  value: string;
}

const RecommendedCard = ({
  planName,
  tag,
  category,
  persons,
  title,
  price,
  group,
  description,
  images,
  original,
  value
}: Props) => {
  const router = useRouter();

  const handleClick = () => {
    localStorage.setItem("plan", value);
    router.push("/entry");
  };

  return <Card>
      <ImageContainer count={images?.length || 0}>
        {images?.map((image, index) => <img key={index} src={image} alt={title} height={392} width={392} />)}
      </ImageContainer>
      <TagWrapper original={original}>
        {tag && <Tag>{tag}</Tag>}
        <PlanName original={original}>
          {original ? <>
              Original<span>Plan</span>
            </> : <>
              Plan<span>{planName}</span>
            </>}
        </PlanName>
      </TagWrapper>
      <InfoContainer>
        <p>{category}</p>
        <p>{persons}</p>
      </InfoContainer>
      <TitleWrapper original={original}>
        <h3>{title}</h3>
        {price && group && <Price>
            <p className="price">
              1名あたり<span>{price}</span> 円～
            </p>
            <p className="persons">{group}名様ご利用の場合</p>
          </Price>}
      </TitleWrapper>
      <Content>{description}</Content>
      <Button type="primary" onClick={handleClick}>
        予約・お問い合わせ
      </Button>
    </Card>;
};

export { RecommendedCard };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");